<script>
import store from './store'
import config from './config'
import calcInput from 'apps/bankrate-calculators/components/number-input.vue'
import calculatorEventBus from 'apps/bankrate-calculators/events'
import { mapGetters, mapState } from 'vuex'

const template = store.state.isMobile
  ? require('./mobile-template.html')
  : require('./template.html')

export default {
  template,
  store,
  components: { calcInput },
  data() {
    return {
      config: config,
      showResults: false
    }
  },
  created() {
    this.$store.dispatch('loadConfig', config)
    this.$store.dispatch('calculate')
  },
  computed: {
    ...mapGetters([
      'pageHasErrors',
      'dataChanged',
      'totalMonthlyIncome',
      'totalMonthlyExpenses'
    ]),
    ...mapState(['isMobile', 'mortgagePayment', 'loanAmount'])
  },
  methods: {
    calculate: function() {
      this.showResults = true

      if (!this.dataChanged) {
        return
      }

      this.$store.dispatch('calculate')
      calculatorEventBus.$emit('calculator:calculation')
    },
    trackRateRequest() {
      calculatorEventBus.$emit('calculator:requestRateTable')
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
